import * as R from 'ramda';
import axios from 'axios';
import { v1 as uuid } from "uuid";
import ErrorHandler from './ApiErrorHandle';


const webAppBaseUrl = process.env.REACT_APP_WEBAPP_API_BASE_URL

const contentType = 'application/json'

function CustomException(error) {
  return {
    endpoint: R.pathOr('', ['response', 'config', 'url'], error),
    statusText: R.pathOr('', ['response', 'statusText'], error),
    message: R.pathOr('', ['message'], error),
    status: R.pathOr(500, ['response', 'status'], error),
    data: R.pathOr(null, ['response', 'data'], error),
  };
}

const get = (endpoint, headers, options = {}) => {
  const commonHeaders = {
    'Content-Type': contentType,
    'Access-Control-Allow-Origin': webAppBaseUrl,
    'x-correlation-id': uuid(),
  };

  const commonGetOptions = {
    method: 'GET',
    responseType: 'json',
    ...options,
  };
  return axios.get(endpoint,
    {
      ...commonGetOptions,
      headers: { ...commonHeaders, ...headers },
    })
    .then(response => response.data)
    .catch((error) => {
      ErrorHandler.SetCommonApiHandle(error);
      throw new CustomException(error);
    });
};

const post = (endpoint, payload, headers, options = {}) => {
  const commonHeaders = {
    'Content-Type': contentType,
    'Access-Control-Allow-Origin': webAppBaseUrl,
    'x-correlation-id': uuid(),
  };

  const commonGetOptions = {
    method: 'POST',
    responseType: 'json',
    ...options,
  };
  return axios.post(endpoint,
    payload,
    {
      ...commonGetOptions,
      headers: { ...commonHeaders, ...headers },
    })
    .then(response => response.data)
    .catch((error) => {
      ErrorHandler.SetCommonApiHandle(error);
      throw new CustomException(error);
    });
};



export default {
  get,
  post
  
};
